import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";
import * as Icons from "react-feather";
import Piutang from "./piutang/Piutang";
import Kasir from "./kasir/Kasir";
import Hutang from "./hutang/Hutang";
import RSLuar from "./rsluar/RSLuar";
import DPKeluar from "./dpkeluar/DPKeluar";
import KasKeluar from "./kaskeluar/KasKeluar";
import Umum from "./umum/Umum";
import PTJ from "./ptj/PTJ";
import BM from "./bm/BM";

import Axios from "axios";
import { urlAPI, getUser, getToken } from "utility/Common";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import { useDispatch } from "react-redux";

export default function EditIndex(props) {
  const { jenis, noslip, nobukti } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [selectorJenis] = useState([
    { value: "D", label: "Kas Bank Masuk" },
    { value: "K", label: "Kas Bank Keluar" },
  ]);
  const [selectorCustomer, setSelectorCustomer] = useState([]);
  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [selectorAccount, setSelectorAccount] = useState([]);
  const [loadingAccount, setLoadingAccount] = useState(false);
  const [selectorKompilator, setSelectorKompilator] = useState([]);
  const [selectorCostCenter, setSelectorCostCenter] = useState([]);
  const [loadingKompilatorDanCC, setLoadingKompilatorDanCC] = useState(false);

  const fetchAccount = () => {
    Axios.get(urlAPI + "/v1/account/selector", {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const selectorTemp = response?.data?.result?.rows?.map((obj) => ({
            value: obj?.ACCOUNT,
            label:
              obj?.ACCOUNT === ""
                ? obj?.ACCOUNT
                : obj?.ACCOUNT + " | " + obj?.KETERANGAN,
            name: obj?.KETERANGAN,
          }));
          setSelectorAccount(selectorTemp);
          setLoadingAccount(false);
        } else {
          setSelectorAccount([]);
          setLoadingAccount(false);
        }
      })
      .catch((err) => {
        setLoadingAccount(false);
        if (err.response?.statusText === "Unauthorized") {
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.dataState?.message,
          });
        }
      });
  };

  const fetchDept = () => {
    Axios.get(urlAPI + "/v1/dept/selector", {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const tempData = response?.data?.result?.rows;
          const CCTemp = tempData?.map((obj) => ({
            value: obj?.KODE,
            label: obj?.KODE === "" ? obj?.KODE : obj?.KODE + " | " + obj?.DEPT,
            name: obj?.DEPT,
            kompilator: obj?.KOMPILATOR,
          }));
          const KompilatorTemp = tempData
            ?.filter((filter) => filter.KOMPILATOR !== "")
            .map((obj) => ({
              value: obj?.KOMPILATOR,
              label: obj?.KOMPILATOR + " | " + obj?.DEPT,
              name: obj?.DEPT,
            }));
          setSelectorCostCenter(CCTemp);
          setSelectorKompilator(KompilatorTemp);
          setLoadingKompilatorDanCC(false);
        } else {
          setSelectorCostCenter([]);
          setSelectorKompilator([]);
          setLoadingKompilatorDanCC(false);
        }
      })
      .catch((err) => {
        setLoadingKompilatorDanCC(false);
        if (err.response?.statusText === "Unauthorized") {
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.dataState?.message,
          });
        }
      });
  };

  const fetchSelectorCustomer = () => {
    Axios.get(urlAPI + "/v1/customer/selectorForFaktur", {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const selectorTemp = response?.data?.result?.rows
            ?.filter(
              (filter) => filter.custno !== "" && filter.custno !== "0000"
            )
            .map((obj) => ({
              value: obj?.custno,
              label:
                obj?.custno === ""
                  ? obj?.nmcust
                  : obj?.custno + " | " + obj?.nmcust,
              name: obj?.nmcust,
              kota: obj?.kota,
              alamat: obj?.alamat,
            }));
          setSelectorCustomer(selectorTemp);
          setLoadingCustomer(false);
        } else {
          setSelectorCustomer([]);
          setLoadingCustomer(false);
        }
      })
      .catch((err) => {
        setLoadingCustomer(false);
        if (err.response?.statusText === "Unauthorized") {
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.dataState?.message,
          });
        }
      });
  };

  useEffect(() => {
    setLoadingKompilatorDanCC(true);
    fetchDept();
    setLoadingAccount(true);
    fetchAccount();
    setLoadingCustomer(true);
    fetchSelectorCustomer();
  }, []);

  return (
    <>
      <Row>
        <Col lg="6" md="6" sm="12">
          <Button
            color="flat-danger"
            onClick={() => {
              history.push("/keuangan/kasbank");
            }}
          >
            <Icons.ArrowLeft size={14} /> Kembali
          </Button>
        </Col>
        <Col lg="6" md="6" sm="12">
          <div className="text-right">
            <h1>
              <strong>Kas / Bank: Edit {jenis}</strong>
            </h1>
          </div>
        </Col>
      </Row>
      <br />
      {jenis === "Piutang" && (
        <Piutang
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
          selectorCustomer={selectorCustomer}
          loadingCustomer={loadingCustomer}
        />
      )}
      {jenis === "Kasir" && (
        <Kasir
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator.filter(
            (filter) =>
              filter.value === "AA0" ||
              filter.value === "AB0" ||
              filter.value === "AC0" ||
              filter.value === "AD0" ||
              filter.value === "AJ0" ||
              filter.value === "AF0"
          )}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
        />
      )}
      {jenis === "Hutang" && (
        <Hutang
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
        />
      )}
      {jenis === "RSluar" && (
        <RSLuar
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
        />
      )}
      {jenis === "DPKeluar" && (
        <DPKeluar
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
        />
      )}
      {(jenis === "Kasbon" || jenis === "KasKecil" || jenis === "UangMuka") && (
        <KasKeluar
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
        />
      )}
      {(jenis === "PTJKasKecil" || jenis === "PTJUangMuka") && (
        <PTJ
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
        />
      )}
      {jenis === "BM" && (
        <BM
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
        />
      )}
      {jenis === "Umum" && (
        <Umum
          noSlip={noslip}
          noBukti={nobukti}
          selectorJenis={selectorJenis}
          selectorAccount={selectorAccount}
          loadingAccount={loadingAccount}
          selectorCostCenter={selectorCostCenter}
          selectorKompilator={selectorKompilator}
          loadingKompilatorDanCC={loadingKompilatorDanCC}
          selectorCustomer={selectorCustomer}
          loadingCustomer={loadingCustomer}
        />
      )}
    </>
  );
}
